import { Close } from '@mui/icons-material';
import { Alert, AlertColor, AlertTitle, IconButton, Snackbar } from '@mui/material';
import axios, { AxiosResponse } from 'axios';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { logisticsApi } from '../../../shared';
import * as Sentry from '@sentry/react';

export function Statusbar() {
    const { t } = useTranslation();
    const [status, setStatus] = useState<{ show: boolean; message: string; type: AlertColor | undefined }>({
        show: false,
        message: '',
        type: undefined,
    });

    const onSuccess = (response: AxiosResponse) => {
        if (response.config.successMessage) {
            setStatus({ show: true, message: response.config.successMessage, type: 'success' });
        }
        return response;
    };

    const onError = useCallback(
        (error: any) => {
            if (error.response?.status === 401 || error.response?.status === 403) {
                window.location.href = '/auth/logout';
            }
            if (error.response.status >= 500) {
                Sentry.captureException(error);
                if (error.config.errorMessage) {
                    setStatus({ show: true, message: error.config.errorMessage, type: 'error' });
                } else {
                    setStatus({ show: true, message: t('tryAgainLater'), type: 'error' });
                }
            }
            return Promise.reject(error);
        },
        [t],
    );

    useEffect(() => {
        axios.interceptors.response.use(onSuccess, onError);
        logisticsApi.interceptors.response.use(onSuccess, onError);
    }, [onError]);

    const onClose = () => {
        setStatus({ ...status, show: false });
    };

    return (
        <Snackbar open={status.show} autoHideDuration={6000} onClose={onClose}>
            <Alert
                severity={status.type}
                action={
                    <IconButton size="small" aria-label="close" color="inherit" onClick={onClose}>
                        <Close fontSize="small" />
                    </IconButton>
                }
            >
                {status.type == 'error' && <AlertTitle>{t('something-went-wrong')}</AlertTitle>}
                {status.message}
            </Alert>
        </Snackbar>
    );
}
